<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Tipos Projeto"
      :headers="tipoProjetoHeaders"
      :customHeaders="customHeaders"
      :items="tiposProjeto"
      item-key="IdTipoProjeto"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroTipoProjeto 
      v-model="modalTipoProjeto"
      :tipoProjeto="tipoProjeto"
      @tipoProjetoAdicionado="tipoProjetoAdicionado"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import TipoProjeto from '@/domain/tipoProjeto/TipoProjeto';
import ModalCadastroTipoProjeto from '@/components/tipoProjeto/ModalCadastroTipoProjeto';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'TiposProjetoView',
  components: {
    GridSyclus,
    ModalCadastroTipoProjeto
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100008
      },
      tipoProjetoHeaders: [
        { text: "ID", value: "IdTipoProjeto" },
        { text: "Descrição", value: "Descricao" },
        { text: "Status", value: "Status" },
      ],
      customHeaders: ["Status"],
      loading: false,
      modalTipoProjeto: false,
      tipoProjeto: new TipoProjeto()
    }
  },
  computed: {
    ...mapGetters(['user', 'tiposProjeto']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'resetaTipoProjetoTiposAtividade',
      'fetchTiposProjetoSql',
      'fetchLayoutsSqlUsuario',
      'deleteTipoProjeto',
      'fetchTipoProjetoTiposAtividade'
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100008 });
      await this.fetchTiposProjetoSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalTipoProjeto = true;
      this.tipoProjeto = Object.assign({}, new TipoProjeto());
      this.resetaTipoProjetoTiposAtividade();
    },
    async editItemSelected(payload) {
      if (payload && payload.IdTipoProjeto) {
        this.tipoProjeto = payload;
        this.modalTipoProjeto = true;
        await this.fetchTipoProjetoTiposAtividade(payload.IdTipoProjeto);
      } else if (payload.length) {
        this.tipoProjeto = payload[payload.length - 1];
        this.modalTipoProjeto = true;
        await this.fetchTipoProjetoTiposAtividade(this.tipoProjeto.IdTipoProjeto);
      } else {
        this.showNotification({ text: "Selecione um tipo Projeto para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteTipoProjeto(item.IdTipoProjeto));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os tipos projeto: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um tipo projeto para excluir.', status: 'error' });
      }
    },
    tipoProjetoAdicionado() {
      this.tipoProjeto = Object.assign({}, new TipoProjeto());
    }
  },
  created() {
    changePageTitle('Tipos Projeto');
  }
}
</script>

<style>

</style>